import { Route, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';

import App from './App';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import Login from './pages/Login';
import CreateNewPassword from './pages/CreateNewPassword';
import ForgotPassword from './pages/ForgotPassword';
import CreateAccount from './pages/CreateAccount';
import PersonalizedForm from './pages/PersonalizedForm';
import PrivateRoute from './common/PrivateRoute';
import Profile from './pages/private/Profile';
import UserInfoWrapper from './common/UserInfoWrapper';
import CodeValidation from './pages/CodeValidation';
import RedirectFacebook from './pages/RedirectFacebook';
import Documents from './pages/private/Documents';
import Landing from './pages/Landing';

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route index={true} path="/sign-in" element={<SignIn />} />
      <Route path="/sign-up" element={<SignUp />} />
      <Route path="/login" element={<Login />} />
      <Route path="/create-new-password" element={<CreateNewPassword />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/create-account" element={<CreateAccount />} />
      <Route path="/personalized-form" element={<PersonalizedForm />} />
      <Route path="/reset-password" element={<CodeValidation />} />
      <Route path="/sign-up/facebook" element={<RedirectFacebook />} />
      <Route path="/insider" element={<Landing />} />

      <Route path="" element={<PrivateRoute />}>
        <Route path="/" element={<UserInfoWrapper />}>
          <Route path="/profile" element={<Profile />} />
          <Route path="/documents" element={<Documents />} />
        </Route>
      </Route>
    </Route>
  ),
  {
    future: {
      v7_relativeSplatPath: true,
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipCatchAllRevalidation: true,
      v7_startTransition: true,
      v7_skipActionErrorRevalidation: true,
    } as any,
  }
);
